import { ENUM_ROLES } from './../../module-role/enums/enum-roles';
import { Values } from './../../utils-global/type-values';
import { Injectable } from '@angular/core';
import { ModelUser } from '@module-user/models/model-user';
import { BehaviorSubject, Observable } from 'rxjs';
import { filter, tap, switchMap, map, catchError, take } from 'rxjs/operators';
import { AuthService } from '@auth0/auth0-angular';
import { UserService } from '@module-user/services/user/user.service';

@Injectable({
  providedIn: 'root'
})
export class CurrentUserService {
  private _currentUser$ = new BehaviorSubject<ModelUser>(
    new ModelUser({ id: null })
  );
  constructor(private auth: AuthService, private userService: UserService) {}

  setCurrentUser(user: ModelUser): void {
    this._currentUser$.next(user);
  }

  queryCurrentUser(): Observable<ModelUser> {
    return this.auth.user$.pipe(
      take(1),
      switchMap((profile) => {
        if (!profile) {
          this.auth.logout();
          throw new Error('Unauthorized');
        }

        return this.userService.queryGetCurrentUser().pipe(
          map((user) => {
            const roles: Values<typeof ENUM_ROLES>[] = user.roles || [];
            return new ModelUser({
              ...user,
              isNew: false,
              picture: profile.picture,
              roles
            });
          })
        );
      }),
      tap((user: ModelUser) => this.setCurrentUser(user)),
      catchError((err) => {
        throw err;
      })
    );
  }

  get currentUser$(): Observable<ModelUser> {
    return this._currentUser$.asObservable().pipe(filter((u) => u.id !== null));
  }

  get currentUser(): ModelUser {
    return this._currentUser$.getValue();
  }
}
